import { useFolders, useNotes, useServices } from "@hq/client-react";
import { deriveTitle } from "@hq/core";
import { Command, Dialog } from "@z/ui";
import { useState } from "react";
import { templatesFolderId } from "../templates";
import { useWorkspace } from "../workspace/WorkspaceContext";

/** "New from template": pick a note from the Templates folder and copy it into a fresh note. */
export function TemplatePicker(props: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const ws = useWorkspace();
  const services = useServices();
  const { data: folders } = useFolders();
  const folderId = templatesFolderId(folders ?? []);
  const { data: templates } = useNotes(folderId ? { folderId } : { folderId: "__none__" });
  const [query, setQuery] = useState("");
  const q = query.toLowerCase();
  const matching = (templates ?? []).filter((t) => t.title.toLowerCase().includes(q));

  const pick = async (templateId: string) => {
    const template = templates?.find((t) => t.id === templateId);
    if (!template) return;
    const note = await services.notes.create({
      markdown: template.markdown,
      title: deriveTitle(template.markdown),
    });
    props.onOpenChange(false);
    ws.openNote(note.id, { pinned: true, autoFocus: true });
  };

  return (
    <Dialog.Root open={props.open} onOpenChange={props.onOpenChange}>
      <Dialog.Content showClose={false} className="p-0">
        <Dialog.Title className="sr-only">New note from template</Dialog.Title>
        <Command.Root value={query} onValueChange={setQuery}>
          <Command.Input placeholder="Template…" autoFocus />
          <Command.List>
            <Command.Empty>
              {folderId
                ? "No matching templates"
                : 'Create a folder named "Templates" and add notes to it.'}
            </Command.Empty>
            {matching.map((t) => (
              <Command.Item key={t.id} value={t.id} onSelect={() => void pick(t.id)}>
                {t.title}
              </Command.Item>
            ))}
          </Command.List>
        </Command.Root>
      </Dialog.Content>
    </Dialog.Root>
  );
}
